import { render, staticRenderFns } from "./CymaSidebar.vue?vue&type=template&id=55b1f3a0"
import script from "./CymaSidebar.vue?vue&type=script&lang=js"
export * from "./CymaSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports